module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Max Midnight Green.7fdb73ff.png";